import { getTextCopy } from '../../i18n';

export interface KindleFireTextProps {
    includePeriod?: boolean;
    hrefOverride?: {
        baseUrl?: string;
        gaParameters: {
            key: string,
            value: string
        }[];
    }
}

const KindleFireAppBaseUrl = "https://www.overdrive.com/apps/libby/kindlefire";

export const KindleFireText = ({ hrefOverride, includePeriod = true }: KindleFireTextProps): JSX.Element => {
    let overridenHref: string | null = null;
    if (hrefOverride) {
        const params = hrefOverride.gaParameters.map((param) => `${param.key}=${param.value}`);
        overridenHref = `${hrefOverride.baseUrl ?? KindleFireAppBaseUrl}?${params.join('&')}`;
    }

    return <p>
        <a className="libby-app-group__kindle-fire-link"
            href={overridenHref ?? KindleFireAppBaseUrl}
            rel="noreferrer"
            target="_blank">
            {getTextCopy(includePeriod ? 'libby.downloadFromAmazonAppstoreWithPeriod' : 'libby.downloadFromAmazonAppstore')}
        </a>
    </p>;
};